import { DEFAULT_LOCATIONS, LIFEPOINT, CHECKMARK } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 608a2022701e82d6fe25c397d3926599a53838df',
  staging: 'Token 7ae94cb4e044d89ebd19df5019189b1f14e870ca',
  prod: 'Token a7e82b70516aa6e9372740612611129d0ad97142',
};

const token = selectToken(apiTokens);

const lifepointConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'lifepoint-quantum',

  API_TOKEN: token,
  EMBOLD_CLIENT: LIFEPOINT,

  // toggles

  // login
  SHOW_REGION_SELECTOR: false,
  NETWORKS: {},

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Brentwood },
  LOGIN_NETWORK_NAME: 'lifepointUserId',

  // content
  DISPLAY_NAME: 'Lifepoint',
  FORM_VARIANT: CHECKMARK,
  NO_WELCOME_LINK: false,
  HIGH_QUALITY_INTRO_MODAL: true,
};

export default lifepointConfig;
